import React from "react";
import { Container, Title, Button } from "./styles/sectionheader";

export default function SectionHeader({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

SectionHeader.Title = function SectionHeaderTitle({ children, ...props }) {
  return <Title {...props}>{children}</Title>;
};

SectionHeader.Button = function SectionHeaderButton({ children, ...props }) {
    return <Button {...props}>{children}</Button>;
  };